<template>
    <div class="container pb-4">
        <input
            type="text"
            id="address"
            v-model="address"
            @input="getSuggestions"
            class="form-control2 no-bottom-radius"
            placeholder="Enter your address"
        />
        <ul v-if="suggestions.length">
            <li
                v-for="suggestion in suggestions"
                :key="suggestion.place_id"
                @click="selectSuggestion(suggestion.place_id)">
                {{ suggestion.description }}
            </li>
        </ul>

        <!-- Display extracted address components -->
            <p v-if="suburb"><strong>Suburb:</strong> {{ suburb }}</p>
            <p v-if="city"><strong>City:</strong> {{ city }}</p>
            <p v-if="state"><strong>State/Province:</strong> {{ state }}</p>
            <p v-if="country"><strong>Country:</strong> {{ country }}</p>
    </div>
</template>

<script>
export default {
    data() {
        return {
            address: null,
            suggestions: [],
            suburb: null,
            city: null,
            state: null,
            country: null,
            selectedAddress: null,
            autocompleteService: null,
            placesService: null,
        };
    },
    mounted() {
        this.autocompleteService = new google.maps.places.AutocompleteService();
        this.placesService = new google.maps.places.PlacesService(document.createElement('div'));
    },

    computed: {
        clearSuggestions() {
            if (this.address === '') {
                this.address = null;
                this.suggestions = [];
                this.suburb = null;
                this.city = null;
                this.state = null;
                this.country = null;
                this.selectedAddress = null;
            }
        },
    },

    methods: {
        getSuggestions() {
            if (this.address.length > 2) {
                this.autocompleteService.getPlacePredictions(
                    {
                        input: this.address,
                        componentRestrictions: { country: 'za' }, // Restrict to South Africa
                        types: ['geocode', 'establishment'], // Include both addresses and places
                    },
                    (predictions, status) => {
                        if (status === google.maps.places.PlacesServiceStatus.OK) {
                            this.suggestions = predictions;
                        }
                    }
                );
            } else {
                this.suggestions = [];
            }
        },
        selectSuggestion(placeId) {
            this.placesService.getDetails({ placeId }, (place, status) => {
                if (status === google.maps.places.PlacesServiceStatus.OK) {
                    this.address = place.formatted_address;
                    this.selectedAddress = place;

                    // Reset variables
                    this.suburb = '';
                    this.city = '';
                    this.state = '';
                    this.country = '';

                    // Extract the address components
                    place.address_components.forEach((component) => {
                        const types = component.types;

                        if (types.includes('sublocality') || types.includes('locality')) {
                            this.suburb = component.long_name;
                        }

                        if (types.includes('administrative_area_level_2')) {
                            this.city = component.long_name;
                        }

                        if (types.includes('administrative_area_level_1')) {
                            this.state = component.long_name;
                        }

                        if (types.includes('country')) {
                            this.country = component.long_name;
                        }
                    });

                    // Clear suggestions after selection
                    this.suggestions = [];
                }
            });
        },
    },
};
</script>

<style scoped>
ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
    border: 1px solid #ccc;
    max-height: 150px;
    overflow-y: auto;
    border-top: none;
}
li {
    padding: 8px;
    cursor: pointer;
}
li:hover {
    background-color: #f0f0f0;
}

.form-control2.no-bottom-radius {
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
</style>
